import React from 'react';
import { Paper, Box, Typography, Icon } from '@mui/material';

interface DashboardMetricCardProps {
  title: string;
  value: number | string;
  icon: string;
  color: string;
}

const DashboardMetricCard: React.FC<DashboardMetricCardProps> = ({
  title,
  value,
  icon,
  color
}) => {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 3,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: 3
        }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          {title}
        </Typography>
        <Box
          sx={{
            backgroundColor: `${color}20`,
            borderRadius: '50%',
            width: 40,
            height: 40,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Icon sx={{ color: color }}>{icon}</Icon>
        </Box>
      </Box>
      <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mt: 'auto' }}>
        {value}
      </Typography>
    </Paper>
  );
};

export default DashboardMetricCard;
